export default "__VITE_ASSET__NL7DvLAQ__"